import { Provider } from '@angular/core';
import { CUSTOMERS_PROVIDERS } from '@features/customers/public-api';
import {
  FinanceCashPreferencesApiService,
  FinanceCashPreferencesService,
} from '@features/finance/public-api';
import { SalesOrdersApiService } from '@features/sales/data-access/sales-orders-api.service';
import { SalesOrdersService } from '@features/sales/services/sales-orders.service';
import { PosCatalogApiService } from './data-access/pos-catalog-api.service';
import { PosDeliveryZonesApiService } from './data-access/pos-delivery-zones-api.service';
import { PosOrderApiService } from './data-access/pos-order-api.service';
import { PosPaymentMethodsApiService } from './data-access/pos-payment-methods-api.service';
import { PosStorePaymentMethodsApiService } from './data-access/pos-store-payment-methods-api.service';
import { PosReportsApiService } from './data-access/pos-reports-api.service';
import { PosSavedCartsApiService } from './data-access/pos-saved-carts-api.service';
import { PosTablesApiService } from './data-access/pos-tables-api.service';
import { PosCatalogService } from './services/pos-catalog.service';
import { PosCheckoutService } from './services/pos-checkout.service';
import { PosPaymentMethodsService } from './services/pos-payment-methods.service';
import { PosReportsService } from './services/pos-reports.service';
import { PosSavedCartsService } from './services/pos-saved-carts.service';
import { PosTablesService } from './services/pos-tables.service';
import { PosTablesRealtimeService } from './services/pos-tables-realtime.service';
import { PosMesaSessionOrchestrationService } from './services/pos-mesa-session-orchestration.service';
import { PosCheckoutOrchestrationService } from './services/pos-checkout-orchestration.service';
import { PosLocalCartsService } from './services/pos-local-carts.service';
import { PosKitchenService } from './services/pos-kitchen.service';
import { PosSettingsPreferencesService } from './services/pos-settings-preferences.service';
import { PosPrintService } from './services/pos-print.service';
import { PosCancelReasonsApiService } from './data-access/pos-cancel-reasons-api.service';
import { PosCancelReasonsService } from './services/pos-cancel-reasons.service';
import { PosLocationKitchenApiService } from './data-access/pos-location-kitchen-api.service';
import { PosKitchenRoutingApiService } from './data-access/pos-kitchen-routing-api.service';
import { PosPrintIdentityApiService } from './data-access/pos-print-identity-api.service';
import { PosDocumentPrintApiService } from './data-access/pos-document-print-api.service';
import { PosLocationUiPreferencesApiService } from './data-access/pos-location-ui-preferences-api.service';
import { PosCatalogLayoutApiService } from './data-access/pos-catalog-layout-api.service';
import { PosPrintAgentApiService } from './data-access/pos-print-agent-api.service';
import { PosPrintIdentityService } from './services/pos-print-identity.service';
import { PosPrintReprintService } from './services/pos-print-reprint.service';
import { PosPrintAgentService } from './services/pos-print-agent.service';
import { PosOrdersHubOrchestrationService } from './services/pos-orders-hub-orchestration.service';
import { PosKitchenRoutingService } from './services/pos-kitchen-routing.service';
import { PosSalesOrderComandaPrinterService } from './services/pos-sales-order-comanda-printer.service';
import { PosCatalogLayoutService } from './services/pos-catalog-layout.service';

export const POS_PROVIDERS: Provider[] = [
  ...CUSTOMERS_PROVIDERS,
  // Pedidos hub lista Web pending vía SalesOrders*; debe vivir en el mismo injector
  // que PosOrdersHubOrchestrationService (padre `/pos`), no solo en la ruta hija.
  SalesOrdersApiService,
  SalesOrdersService,
  PosCatalogApiService,
  PosDeliveryZonesApiService,
  PosOrderApiService,
  PosPaymentMethodsApiService,
  PosStorePaymentMethodsApiService,
  PosTablesApiService,
  PosSavedCartsApiService,
  PosReportsApiService,
  PosCancelReasonsApiService,
  PosLocationKitchenApiService,
  PosKitchenRoutingApiService,
  PosKitchenRoutingService,
  PosPrintIdentityApiService,
  PosDocumentPrintApiService,
  PosLocationUiPreferencesApiService,
  PosCatalogLayoutApiService,
  PosPrintAgentApiService,
  PosCatalogService,
  PosCatalogLayoutService,
  PosCheckoutService,
  PosCheckoutOrchestrationService,
  PosPaymentMethodsService,
  PosTablesService,
  PosTablesRealtimeService,
  PosMesaSessionOrchestrationService,
  PosLocalCartsService,
  PosSavedCartsService,
  PosOrdersHubOrchestrationService,
  PosReportsService,
  PosKitchenService,
  PosSettingsPreferencesService,
  PosPrintService,
  PosPrintIdentityService,
  PosPrintReprintService,
  PosPrintAgentService,
  PosSalesOrderComandaPrinterService,
  PosCancelReasonsService,
  FinanceCashPreferencesApiService,
  FinanceCashPreferencesService,
];
